<div class="footer-logo">
  <a [routerLink]="['/']">
    @if (logo?.visible) {
      @if (logo?.options?.["logo"]?.visible) {
        <img
          [src]="logo?.options?.['logo']?.value"
          class="img-fluid"
          alt="logo"
        />
      } @else if (logo?.options?.["title"]?.visible) {
        <h2 class="f-w-600">{{ logo?.options?.["title"]?.value }}</h2>
      }
    }
  </a>
</div>
